<div class="claseheader">
  <div class="box headinguser">
    <div class="notificacionnumber" *ngIf="numeromensajes>1">
      {{numeromensajes}}
    </div>
    <div
      class="avatarbox"
      routerLink="/dashboard/profile/{{ datosEmisor.uid }}"
      
    >
   
      <img
        *ngIf="datosEmisor.avatar"
        [src]="datosEmisor.avatar"
      />
      <div *ngIf="!datosEmisor.avatar || datosEmisor.avatar == ''">
         <img src="../../../../assets/img/defaultavatar.jpg" alt="">
      </div>
      <p>
        <b>
          {{ datosEmisor.name | titlecase }}
          {{ datosEmisor.last_name | titlecase }}
        </b>
      </p>
    </div>

    <div class="boxtitles" *ngIf="this.datosNotificacion.message">
      <h4>
        {{ datosEmisor.name | titlecase }}
        {{ datosEmisor.last_name | titlecase }}:
      </h4>
      <h4>{{ getNotificationContent() }}</h4>
    </div>
    <div class="boxtitles" *ngIf="this.datosNotificacion.event_id">
      <h4 translate> dashboard.notificaciones.evento</h4>
      <h4>{{ getNotificationContent() }}</h4>
    </div>
    <div
      class="rightbuttons"
      *ngIf="this.datosNotificacion.message"
    >
      <ng-container *ngIf="getNotificationUrl()">
        <a
          (click)="deletenotificacion()"
          routerLink="{{ getNotificationUrl() }}"
          translate
          >
          dashboard.notificaciones.ver
        </a>
      </ng-container>

      <br />

      <!-- <a (click)="deletenotificacion()" translate>
        dashboard.notificaciones.eliminar </a> -->
    </div>

    <div class="rightbuttons" *ngIf="this.datosNotificacion.event_id">
      <ng-container *ngIf="getNotificationUrl()">
        <a
          (click)="vernotificacion(idNotificacion)"
          routerLink="{{ getNotificationUrl() }}"
          translate
          >
          dashboard.notificaciones.ver
        </a>
      </ng-container>

      <br />

      <a (click)="deletenotificacion()" translate>
        dashboard.notificaciones.eliminar </a>
    </div>
  </div>
</div>



